import { render, staticRenderFns } from "./RequestsAll.vue?vue&type=template&id=236130f8&scoped=true"
import script from "./RequestsAll.vue?vue&type=script&lang=js"
export * from "./RequestsAll.vue?vue&type=script&lang=js"
import style0 from "./RequestsAll.vue?vue&type=style&index=0&id=236130f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236130f8",
  null
  
)

export default component.exports